export function convertMessageToHtml(message: string): string {
  return message.replace(/\n\r/g, '<br>');
}
